import { videoHotlineCatgoryConstants } from "../actions/constants/videoHotlineCategoryConstants";

type VideoHotlineCategoryDataState = {
	items: any[];
};

const initialVideoHotlineCategorysData: VideoHotlineCategoryDataState = {
	items: [],
};

const videoHotlineCategoryData = (
	state = initialVideoHotlineCategorysData,
	action: any
) => {
	switch (action.type) {
		// Use for get category list & serach result
		case videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		// Use to update the category status
		case videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFormSubmit: true,
				isUpdateStatus: false,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.status,
			};

		// Use to create the category status
		case videoHotlineCatgoryConstants.VideoHotlineCategoryCreateRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				isSuccessSave: false,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryCreateSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				isSuccessSave: true,
				status: action.payload.status,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryCreateFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isSuccessSave: false,
				isError: true,
				status: action.payload.status,
			};

		// Use to update the category status
		case videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				isSuccessSave: false,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				isSuccessSave: true,
				status: action.payload.status,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isSuccessSave: false,
				isError: true,
				status: action.payload.status,
			};
		// Use to Delete the category status
		case videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		default:
			return state;
	}
};

export default videoHotlineCategoryData;
